import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { ITeamMast } from "../../teamManagement/Table";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../../models/IDropdown";
import { Fetch } from "../../../shared/Fetch";
import { EmptyTeam } from "./EmptyTenderTeam";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdown } from "../../../shared/JVDropdown";
import { ITenderTeamManagement } from "../../../models/TenderTeamManagment";

const schema = yup.object({
    Team_Name: yup.string().required("Team Name is required*").min(3),
    Company_Name: yup.number().required("Company is required*"),
    Branch_Name: yup.number().when("Company_Name", {
        is: (val: string) => val==="",
        then: yup.number().nullable(),
        otherwise: yup.number().required("Branch is required"),
    }),
    TeamManagerid: yup.number().when("Branch_Name", val => {
        return (val === "") ?
        yup.number().nullable():
        yup.number().required("Team Manager is required*");
    }),
});

interface Iprops {
    singleData: ITenderTeamManagement,
    teamNameList: ITeamMast[],
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

interface Users {
    branch_ID?: number,
    login_ID?: number,
    user_Name?: string,
}

export const Form = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [diable,setDisable] = useState({branch:true, teamManage:true});
    const [users,setUsers] = useState<Array<Users>>();
    const [methd,setMethd] = useState("POST");
    const [teamNames,setTeamNames] = useState<Array<string | undefined>>([]);

    let x:string | null=sessionStorage.getItem('auth') || "null";
    let loginObj=JSON.parse(x);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<ITenderTeamManagement>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "Company_Name") {
                if (value.Company_Name != 0){
                    setDisable({branch:false, teamManage:true});
                    const loadBranches = async () => {
                        const response = await Fetch("Dropdown/branches", "GET", null, `company_id=${value.Company_Name}`, null);
                        if (response) {
                            const data: Array<IBranchMastDropdown> = await response.json();
                            setBranches(data);
                        }
                    }
                    loadBranches();
                } else {
                    setDisable({branch:true, teamManage:true});
                }
            }

            if(name === "Branch_Name"){
                if (value.Branch_Name != 0){
                    setDisable({branch:false, teamManage:false});
                    const loadUsers = async () => {
                        const response = await Fetch("Dropdown/UsersByBranch", "GET", null, `branch_ID=${value.Branch_Name}`, null);
                        if (response) {
                            const data: Array<Users> = await response.json();
                            // console.log(data);
                            setUsers(data);
                        }
                    }
                    loadUsers();
                } else {
                    setDisable({branch:false, teamManage:true});
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(data);
        }
    }

    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(()=>{
        let list: (string | undefined)[] = props.teamNameList.map(el=>el.team_Name);
        setTeamNames(list);
    },[props.open]);
    

    useEffect(() => {
        if(props.singleData.Branch_Name != 0){
            setDisable({branch:false, teamManage:true});
            setMethd("PUT");
            const loadBranches = async () => {
                const response = await Fetch("Dropdown/branches", "GET", null, `company_id=${props.singleData.Company_Name}`, null);
                if (response) {
                    const data: Array<IBranchMastDropdown> = await response.json();
                    setBranches(data);
                }
            }
            loadBranches();
        }
        if(props.singleData.TeamManagerid != 0){
            setMethd("PUT");
            setDisable({branch:false, teamManage:false});
            const loadUsers = async () => {
                const response = await Fetch("Dropdown/UsersByBranch", "GET", null, `branch_ID=${props.singleData.Branch_Name}`, null);
                if (response) {
                    const data: Array<Users> = await response.json();
                    setUsers(data);
                }
            }
            loadUsers();
        }
        reset(props.singleData);
    }, [props.singleData]);

    // interface Branches {
    //     branch_ID: number
    // }

    const saveToDB = async (body: ITenderTeamManagement) => {
        let data: ITenderTeamManagement;
        if(body.Team_ID){
            data = body;
        } else {
            data = {
                Team_Name: body.Team_Name,
                Status: true,
                Added_By: loginObj.id,
                Added_On: new Date(),
                TeamManagerid: body.TeamManagerid,
            };
        }
        const method = methd==="POST" ? "POST" : "PUT";
        const message = methd==="POST" ? "Added Successfully" : "Updated Successfully";

        let teamNameAvail = true;

        let newTeamName = body.Team_Name;

        for(let i=0;i<teamNames.length;i++){
            if(newTeamName?.trim().replace(/\s+/g, "").split(" ").join(" ").toLowerCase() === teamNames[i]?.trim().replace(/\s+/g, "").split(" ").join(" ").toLowerCase()){
                teamNameAvail = false;
                i=teamNames.length;
            }
        }

        if(!teamNameAvail && method === "POST"){
            props.toast.current.show({ severity: 'error', detail: "This Team Name is already exist", life: 3000 });
        } else {
            if(data.TeamManagerid === null || data.TeamManagerid === 0){
                props.toast.current.show({ severity: 'error', detail: "Please Select Team Manager", life: 3000 });
            } else {
                const response = await Fetch("Tender_Pre_Sales_Team_Mast", method, data, null, props.toast);
                if (response) {
                    onHide();
                    props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                    props.setReload(!props.reload);
                } else {
                    props.toast.current.show({ severity: 'error', detail: "This Team Name is already exist", life: 3000 });
                }
            }
        }
    }

    useEffect(()=>{
       if(control._formValues.Company_Name === "" && control._formValues.Branch_Name != "") props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
    },[control._formValues.Branch_Name]);

    const onHide = () => {
        setMethd("POST");
        props.hideDialog();
        reset(EmptyTeam);
        setDisable({branch:true, teamManage:true});
    }

    function onSubmit(data: ITenderTeamManagement) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Tender Team" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput    required label=" Tender Team Name"    control={control} name="Team_Name"    error={errors.Team_Name?.message} />
                <JVDropdown required label="Company"      control={control} name="Company_Name" error={errors.Company_Name?.message} options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
                <JVDropdown required label="Branch"       control={control} name="Branch_Name"  disabled={diable.branch} error={errors.Branch_Name?.message}  options={branches}  optionLabel="branchName"   optionValue="branch_ID" placeholder="Select Branch" />
                <JVDropdown required label="Team Manager" control={control} name="TeamManagerid" disabled={diable.teamManage} error={errors.TeamManagerid?.message} options={users}  optionLabel="user_Name"   optionValue="login_ID" placeholder="Select Team Manager" />
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit"></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}